/* @jsxRuntime automatic */
/* @jsxImportSource @superweb/css */

import { useEffect, useRef } from "react";

import { useLocale } from "@superweb/intl";
import type { ComboBoxOption, ComboBoxState } from "@superweb/ui";

import { useQuery } from "@fleet/api";

import { useValidate } from "#internal/utils";

import { FormSuggest } from "./form-suggest";

export const CountrySuggest = ({
  label,
  countryId,
  state,
  onChange,
}: {
  label: string;
  countryId: string;
  state: ComboBoxState<ComboBoxOption>;
  onChange: (value: ComboBoxState<ComboBoxOption>) => void;
}) => {
  const locale = useLocale();
  const { validateComboboxField } = useValidate();

  const mounted = useRef(false);

  const { response } = useQuery({
    url: "/fleet-forms/selfreg/v1/countries",
    method: "GET",
    headers: {
      language: locale.toString(),
    },
  });

  const countriesOptions = response.body.countries.map(({ id, name }) => ({
    label: name,
    key: id,
  }));

  useEffect(() => {
    if (!mounted.current) {
      const countryName = response.body.countries.find(
        ({ id }) => id === countryId,
      )?.name;
      if (countryName) {
        onChange({
          ...state,
          value: { key: countryId, label: countryName },
          errorMessage: undefined,
        });
      }
      mounted.current = true;
    }
  }, [response, countryId, onChange, state]);

  return (
    <FormSuggest
      data={countriesOptions}
      label={label}
      state={state}
      onChange={(newState) => {
        const errorMessage = validateComboboxField(newState);
        onChange({
          ...newState,
          errorMessage,
          errorVisible: Boolean(errorMessage),
        });
      }}
      enableFilterOptionsOnInputValue
    />
  );
};
